import React from 'react'
import PropTypes from 'prop-types'
import PDFContainer from './PDFContainer'

function PDFLink(props) {
  return <PDFContainer url={props.item.link_url} />
}

PDFLink.propTypes = {
  item: PropTypes.object.isRequired
}

export default PDFLink